import React, { useEffect, useState } from 'react';
import { PagePath } from '../../../navigation/navigation.enums';
import { PageLoaderLayer } from '../../../components/general/loading-state/loader-layers/page-loader-layer/page-loader-layer';
import { PageHeader } from '@keplerco/core';
import { useAppActions, useAppState } from '../../../overmind';
import { useParams } from 'react-router';
import { FetchType } from '../../../enums';
import SummaryStep from './summary-step/summary-step';
import { GetSkillCategoryResponse } from '../../../overmind/actions';

export function SkillCategoriesViewPage(): React.ReactElement {
  const { skillCategorySlug } = useParams();

  const actions = useAppActions();
  const { companyVariables } = useAppState();

  const [skillCategory, setSkillCategory] = useState<GetSkillCategoryResponse>();

  useEffect(() => {
    async function getData() {
      actions.startLoader({ path: PagePath.roleSkillManagementSkillCategoriesEdit, type: FetchType.PageFetching });

      const response = await actions.readSkillCategory(skillCategorySlug!);
      setSkillCategory(response);

      actions.stopLoader(PagePath.roleSkillManagementSkillCategoriesEdit);
    }

    getData();
  }, [skillCategorySlug]);

  return (
    <PageLoaderLayer path={PagePath.roleSkillManagementSkillCategoriesEdit}>
      <div className="wrapper stack" style={{ paddingBottom: 24, gap: 24 }}>
        <PageHeader
          breadcrumbs={[
            { name: 'Roles & skills', url: `${PagePath.roleSkillManagementBase}` },
            { name: 'Manage skill categories', url: `${PagePath.roleSkillManagementBase}${PagePath.roleSkillManagementSkillCategories.replace(':companySlug', companyVariables.slug!)}` },
            { name: skillCategory?.name ?? 'View skill category', url: location.href },
          ]}
          title={skillCategory?.name ?? 'View skill category'}
        />

        {!!skillCategory && <SummaryStep skillCategory={skillCategory} />}
      </div>
    </PageLoaderLayer>
  );
}
